import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable(
 { providedIn: "root"}
)
export class ShareDataService {

  private isAppeal = new BehaviorSubject<boolean>(false);
  public readonly currentIsAppeal = this.isAppeal.asObservable();
   constructor() {
  
    }

  getRadioButtonId(namespace: string, customName: string) {
    return `${namespace}_Radio_${customName}`;
  }

}
